<template>
  <v-dialog :value="value" max-width="500" persistent>
    <v-card class="end-mode-dialog">
      <v-card-title class="end-mode-header white--text">
        <v-icon class="mr-3" color="white" size="24">mdi-calendar-check</v-icon>
        <span class="end-mode-header-title">How should this bus change end?</span>
        <v-spacer></v-spacer>
        <v-btn icon dark class="my-0" @click="$emit('cancel')">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-3 pb-2">
        <div v-if="rangeText" class="end-mode-range mb-3">
          <v-icon small color="#2e7d32" class="mr-2">mdi-calendar-range</v-icon>
          <span>{{ rangeText }}</span>
        </div>

        <div
          class="end-mode-option end-mode-option-primary mb-2"
          :class="{
            'end-mode-option-current': showCurrent && currentlyStopOnEndDate,
          }"
          @click="$emit('choose', true)"
        >
          <div class="end-mode-option-icon end-mode-option-icon-primary">
            <v-icon color="white" size="22">mdi-calendar-check</v-icon>
          </div>
          <div class="end-mode-option-body">
            <div class="end-mode-option-head">
              <span class="end-mode-option-title">End itself on the end date</span>
              <span
                v-if="showCurrent && currentlyStopOnEndDate"
                class="end-mode-current-tag"
              >
                Current
              </span>
            </div>
            <div class="end-mode-option-desc">
              Stops on the end date. You do not need to run End Bus Change.
            </div>
          </div>
          <v-icon class="end-mode-chevron">mdi-chevron-right</v-icon>
        </div>

        <div
          class="end-mode-option"
          :class="{
            'end-mode-option-current': showCurrent && !currentlyStopOnEndDate,
          }"
          @click="$emit('choose', false)"
        >
          <div class="end-mode-option-icon end-mode-option-icon-manual">
            <v-icon color="#2e7d32" size="22">mdi-autorenew</v-icon>
          </div>
          <div class="end-mode-option-body">
            <div class="end-mode-option-head">
              <span class="end-mode-option-title">Keep going until ended</span>
              <span
                v-if="showCurrent && !currentlyStopOnEndDate"
                class="end-mode-current-tag"
              >
                Current
              </span>
            </div>
            <div class="end-mode-option-desc">
              Extends by one day each day until someone runs End Bus Change.
            </div>
          </div>
          <v-icon class="end-mode-chevron">mdi-chevron-right</v-icon>
        </div>
      </v-card-text>

      <v-card-actions class="px-3 pb-3 pt-1">
        <v-spacer></v-spacer>
        <v-btn color="default" dark @click="$emit('cancel')">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    rangeText: { type: String, default: "" },
    currentlyStopOnEndDate: { type: Boolean, default: false },
    showCurrent: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.end-mode-header {
  background: linear-gradient(135deg, #43a047 0%, #66bb6a 100%);
  padding: 12px 16px;
}

.end-mode-header-title {
  font-size: 18px;
  font-weight: 500;
}

.end-mode-range {
  display: flex;
  align-items: center;
  background: #f1f8f2;
  border: 1px solid #c8e6c9;
  border-radius: 6px;
  padding: 8px 12px;
  color: #1b5e20;
  font-size: 13px;
  font-weight: 600;
}

.end-mode-option {
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  background: #ffffff;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.end-mode-option:hover {
  border-color: #4caf50;
  background: #f7fbf8;
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.14);
}

.end-mode-option-primary {
  border-color: #a5d6a7;
  background: #fafdfb;
}

.end-mode-option-current {
  border-color: #4caf50;
  box-shadow: inset 0 0 0 1px #4caf50;
}

.end-mode-option-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 12px;
}

.end-mode-option-icon-primary {
  background: #4caf50;
}

.end-mode-option-icon-manual {
  background: #e8f5e9;
}

.end-mode-option-body {
  flex: 1;
  min-width: 0;
}

.end-mode-option-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.end-mode-option-title {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.end-mode-option-desc {
  font-size: 12.5px;
  color: #616161;
  margin-top: 2px;
  line-height: 1.35;
}

.end-mode-current-tag {
  margin-left: 8px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #e8f5e9;
  color: #2e7d32;
  font-size: 11px;
  font-weight: 600;
}

.end-mode-chevron {
  color: #9e9e9e;
  margin-left: 8px;
}

.end-mode-option:hover .end-mode-chevron {
  color: #2e7d32;
}
</style>
